const mbg_id = {
    common: {
        account_name: 'nama rekening',
        account_number: 'nomor rekening',
        kitchen: "dapur",
        ktp: 'KTP',
        project: 'proyek',
        region: 'wilayah',
        balance_active: 'saldo aktif',
        balance_pending: 'saldo pending',
        balance_total: 'saldo total',
        supplier: "pemasok",
        zip: 'kode pos',
    },
    menu: {
        so: "sales order (SO)",
        do: "delivery order (DO)",
        funding: 'tagihan',
        kitchen: "dapur",
        project: 'proyek',
        project_list: 'daftar proyek',
        request: 'penjualan',
        supplier: "pemasok",
        notif_price: "perubahan harga",
    },
    funding: {
        "date": "tanggal",
        "detail": "detail tagihan",
        "due_date": "tanggal jatuh tempo",
        "invoice": "nomor invoice",
        "po": "nomor PO",
        "pdf": "lihat PDF",
    },
    kitchen: {
        "name": "nama dapur",
        "pic": "PIC gudang dapur",
        "phone": "no. telp dapur",
        "fax": "fax dapur",
        "email": "email dapur",
        "add": "tambah dapur",
        "edit": "ubah dapur",
        "logo": "logo dapur",
    },
    project: {
        "name": "nama proyek",
        "date": "tanggal proyek",
        "date_new_end_date": "tanggal akhir baru proyek",
        'add': "tambah proyek",
        'edit': "ubah proyek",
        "extend": "perpanjang proyek",
        'view': "detail proyek",
        "kitchen": "daftar dapur proyek",
        "add_kitchen": "tambah dapur",
        "edit_kitchen": "ubah dapur",
        "delete_kitchen": "hapus dapur",
    },
    request: {
        "detail": "detail penjualan"
    },
    supplier: {
        "name": "nama pemasok",
        "pic": "PIC gudang pemasok",
        "phone": "no. telp pemasok",
        "fax": "fax pemasok",
        "email": "email pemasok",
        "add": "tambah pemasok",
        "edit": "ubah pemasok",
        "logo": "logo pemasok",
        "sku": "SKU pemasok",
        "add_sku": "tambah SKU pemasok",
        "edit_sku": "ubah SKU pemasok",
    },
    notif_price: {

    }
}
export default mbg_id;